import React from 'react';
import {
  Grid,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  DialogActions,
  Typography,
  Button,
  useTheme,
} from '@mui/material';
import propTypes from 'prop-types';
import { ReactComponent as CloseIcon } from '../../assets/CloseIcon.svg';
import DialogTransition from './DialogTransition';

const DeleteDialog = ({
  open,
  onCloseClick,
  onDeleteClick,
  resourceName,
  confirmationMsg,
}) => {
  const theme = useTheme();

  return (
    <Dialog
      onClose={onCloseClick}
      maxWidth="xs"
      fullWidth={true}
      TransitionComponent={DialogTransition}
      open={open}
    >
      <DialogTitle>{`Delete ${resourceName}`}</DialogTitle>
      <IconButton
        onClick={onCloseClick}
        size="large"
        sx={{ position: 'absolute', right: 16, top: 8 }}
      >
        <CloseIcon style={{ color: theme.palette.other.icon }} />
      </IconButton>
      <DialogContent dividers sx={{ padding: '0px' }}>
        <Grid container direction="column" px={4}>
          <Grid
            item
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            height="84px"
          >
            <Box width="100%">
              <Typography variant="subtitle1">{confirmationMsg}</Typography>
            </Box>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={onCloseClick}>
          No
        </Button>
        <Button variant="contained" onClick={onDeleteClick}>
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
};

DeleteDialog.propTypes = {
  open: propTypes.bool.isRequired,
  onCloseClick: propTypes.func.isRequired,
  onDeleteClick: propTypes.func.isRequired,
  resourceName: propTypes.string.isRequired,
  confirmationMsg: propTypes.string.isRequired,
};

export default DeleteDialog;
